import recursiveFunctionStepParser from '../recursiveFunctionStepParser';
import resolveExpression from '../simpleScript/expressionParser/resolveExpression';

export default async function(
    functionObj={},
    variableObject={},
    parameterObject={},
    functionMap={},
    variableIdMap={},
    setStateFunction
){
    try{
        const {
            executionObject={}
        } = functionObj;
        const {
            timeoutMs={}, functionObject={},
            variableName=''
        } = executionObject;

        if(!variableName){
            return {
                updatedVariableObject : variableObject,
                hasError : true,
                errorPayload : 'Variable name is missing.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        let variableCopy = variableObject;
        const {
            functionSteps=[]
        } = functionObject;
        let normalizedFunctionSteps = [];
        for (let k = 0; k < functionSteps.length; k++){
            let workflow = functionSteps[k];
            let steps = workflow['functionSteps'] || [];
            normalizedFunctionSteps.push(...steps);
        }

        let resolvedQuery = await resolveExpression(
            timeoutMs,
            variableObject,
            parameterObject,
            functionMap,
            variableIdMap
        );
        let timeoutValue = resolvedQuery.value;
        variableCopy = resolvedQuery.variableObject;

        let intervalId = setInterval(function(){
            recursiveFunctionStepParser(
                normalizedFunctionSteps, 
                variableCopy, 
                parameterObject, 
                functionMap,
                variableIdMap,
                setStateFunction
            )
        }, timeoutValue);
        variableCopy[variableName] = intervalId;

        return {
            hasReturnStatement : false,
            returnStatement : undefined,
            updatedVariableObject : variableCopy,
            hasError : false,
            errorPayload : undefined
        };
    }catch(e){
        console.log('/utils/functionParser/general/functionTypeParser/setIntervalParser catch block error', e)
        return {
            updatedVariableObject : variableObject,
            hasError : true,
            errorPayload : e.stack,
            hasReturnStatement : false,
            returnStatement : undefined
        }
    }
}